import { render, staticRenderFns } from "./SwitchGrouped.vue?vue&type=template&id=701e8417"
import script from "./SwitchGrouped.vue?vue&type=script&lang=js"
export * from "./SwitchGrouped.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports